module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fnzGs"))).then(() => parcelRequire('d0iPb'));